import { SetDefaultData, FetchDiscountGroupRequest, UpdateField, UpdateDiscountGroupRequest } from './../discount-groups.actions';
import { getUpdateDiscountGroupState } from '../discount-groups.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-update-discount-group',
  templateUrl: './update-discount-group.component.html',
  styleUrls: ['./update-discount-group.component.css']
})
export class UpdateDiscountGroupComponent extends FormTrait implements OnInit, OnDestroy {

  private state$: Subscription;
  public isLoading: boolean;
  public PaymentPurposeId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.PaymentPurposeId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updateDiscountGroup'))
    this.state$ = this.store.pipe(select(getUpdateDiscountGroupState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchDiscountGroupRequest(this.PaymentPurposeId))
  }

  ngOnDestroy(){
    this.state$.unsubscribe();
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updateDiscountGroup.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updateDiscountGroup')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required",
      percentage: "required|numeric|min:0|max:100",
    };
    const validator = new Validator(
      data.toJS(),
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').set('percentage', parseFloat(this.state.get('data').get('percentage'))).toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdateDiscountGroupRequest(this.PaymentPurposeId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updateDiscountGroup')
      );
    }
  }

}
